/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbTimepickerModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { BranchFilterService } from './services/branch-filter.service';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { TourmindComponent } from './pages/tourmind/tourmind.component';
import { PaymentRedirectComponent } from './payment-redirect/payment-redirect.component';
import { ExpandableCellContentComponent } from './pages/custom-components/expandable-cell-content/expandable-cell-content.component';
import { DynamicRendererComponent } from './pages/custom-components/dynamic-renderer/dynamic-renderer.component';

@NgModule({
  declarations: [AppComponent, ExpandableCellContentComponent, DynamicRendererComponent],
  imports: [
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    MatAutocompleteModule,
    NbDatepickerModule.forRoot(),
    NbTimepickerModule.forRoot(),
  ],
  bootstrap: [AppComponent],
  providers: [ BranchFilterService ],
})
export class AppModule {
}
